module.exports = __webpack_public_path__ + "static/nationwide-pathology-ccf848a3f37691fe57bbaedce1bead07.jpeg";